importConf = (arg) -> {
  component: 'upload_file',
  serviceName: 'weaver-importer-exporter'
  serviceCall: 'import',
  config: { wipe: false, memberKey: 'type' }
  profile: arg
}

export default [{
  title: 'Blank'
}, {
  title: 'Upload Excel'
  importConf('raw-xl')...
}, {
  title: 'Upload CSV'
  importConf('raw-csv')...
}, {
  title: 'Upload XML'
  importConf('raw-xml')...
}, {
  title: 'Upload JSON'
  importConf('raw-json')...
}, {
  title: 'Upload Trig'
  importConf('trig')...
}, {
  title: 'Upload Turtle'
  importConf('turtle')...
}, {
  title: 'Upload Weaver Model'
  importConf('yaml-to-rdfs')...
}, {
  title: 'Upload Relatics XML'
  importConf('relatics-stream')...
}, {
  title: 'Upload BIM360 json'
  importConf('bim360')...
}, {
  title: 'Upload Transform Script'
  component: 'upload_file'
  serviceName: 'weaver-transform',
  serviceCall: 'transformFromFile'
}, {
  title: 'Generate Turtle'
  component: 'generate_file'
  serviceName: 'weaver-importer-exporter'
  serviceCall: 'export'
  config: { wipe: false, filename: 'export.ttl' }
  profile: 'turtle'
}, {
  title: 'Machine Learning - Start Training'
  component: 'train_ml'
  serviceName: 'pythia-connector'
  serviceCall: 'train'
}, {
  title: 'Machine Learning - Training Status'
  component: 'status_ml'
  serviceName: 'pythia-connector'
  serviceCall: 'getStatus'
}, {
  title: 'Machine Learning - Predict'
  component: 'predict_ml'
  serviceName: 'pythia-connector'
  serviceCall: 'predict'
}]
